import { Injectable } from '@angular/core';
import { ApiClientService } from '../../core/services/api-client.service';
import { Utilisateur } from './utilisateur.model';

@Injectable({
  providedIn: 'root',
})
export class UtilisateursService extends ApiClientService {
  /**
   * Retrieves all users
   * GET /utilisateurs
   */
  getAllUtilisateurs() {
    return this.get<Utilisateur[]>('/users');
  }
}
